import PtuErrosFiltro from "./componentes/Abas/PtuErros/PtuErrosFiltro";
import PtuErrosDownload from "./componentes/Abas/PtuErros/PtuErrosDownload";

import RpsTotalFiltro from "./componentes/Abas/RpsTotal/RpsTotalFiltro.vue";
import RpsTotalDownload from "./componentes/Abas/RpsTotal/RpsTotalDownload";

import ArpsRpsAnsFiltro from "./componentes/Abas/ArpsRpsAns/ArpsRpsAnsFiltro";
import ArpsRpsAnsDownload from "./componentes/Abas/ArpsRpsAns/ArpsRpsAnsDownload";

import RedeNascionalPrestadoresFiltro from "./componentes/Abas/RedeNascionalPrestadores/RedeNascionalPrestadoresFiltro.vue";
import RedeNascionalPrestadoresDownload from "./componentes/Abas/RedeNascionalPrestadores/RedeNascionalPrestadoresDownload";

import RedimensionamentoHospitalarFiltro from "./componentes/Abas/RedimensionamentoHospitalar/RedimensionamentoHospitalarFiltro";
import RedimensionamentoHospitalarDownload from "./componentes/Abas/RedimensionamentoHospitalar/RedimensionamentoHospitalarDownload";

import RedimensionamentoHospitalarAgiFiltro from "./componentes/Abas/RedimensionamentoHospitalarAgi/RedimensionamentoHospitalarAgiFiltro";
import RedimensionamentoHospitalarAgiDownload from "./componentes/Abas/RedimensionamentoHospitalarAgi/RedimensionamentoHospitalarAgiDownload";

import SubstituicaoPrestadoresFiltro from "./componentes/Abas/SubstituicaoPrestadores/SubstituicaoPrestadoresFiltro";
import SubstituicaoPrestadoresDownload from "./componentes/Abas/SubstituicaoPrestadores/SubstituicaoPrestadoresDownload";

import SubstituicaoPrestadoresAgiFiltro from "./componentes/Abas/SubstituicaoPrestadoresAgi/SubstituicaoPrestadoresAgiFiltro";
import SubstituicaoPrestadoresAgiDownload from "./componentes/Abas/SubstituicaoPrestadoresAgi/SubstituicaoPrestadoresAgiDownload";

import ListaPrestadoresFiltro from "./componentes/Abas/ListaPrestadores/ListaPrestadoresFiltro";
import ListaPrestadoresDownload from "./componentes/Abas/ListaPrestadores/ListaPrestadoresDownload";

import EvolucaoA400Filtro from "./componentes/Abas/EvolucaoA400/EvolucaoA400Filtro";
import EvolucaoA400Download from "./componentes/Abas/EvolucaoA400/EvolucaoA400Download";

import PrestadoresPendentesJustificativaFiltro from "./componentes/Abas/PrestadoresPendentesJustificativa/PrestadoresPendentesJustificativaFiltro.vue";
import PrestadoresPendentesJustificativaDownload from "./componentes/Abas/PrestadoresPendentesJustificativa/PrestadoresPendentesJustificativaDownload";

import PrestadoresIndisponiveisAoIntercambioFiltro from "./componentes/Abas/PrestadoresIndisponiveisAoIntercambio/PrestadoresIndisponiveisAoIntercambioFiltro";
import PrestadoresIndisponiveisAoIntercambioDownload from "./componentes/Abas/PrestadoresIndisponiveisAoIntercambio/PrestadoresIndisponiveisAoIntercambioDownload";

import PrestaoresNaoOperadoraDownload from "./componentes/Abas/PrestaoresNaoOperadora/PrestaoresNaoOperadoraDownload";

import RelatoriosService from "./RelatoriosService";

export default {
  components: {
    PtuErrosFiltro,
    PtuErrosDownload,
    RpsTotalDownload,
    RpsTotalFiltro,
    ArpsRpsAnsFiltro,
    ArpsRpsAnsDownload,
    RedeNascionalPrestadoresFiltro,
    RedeNascionalPrestadoresDownload,
    RedimensionamentoHospitalarDownload,
    RedimensionamentoHospitalarFiltro,
    RedimensionamentoHospitalarAgiDownload,
    RedimensionamentoHospitalarAgiFiltro,
    ListaPrestadoresFiltro,
    ListaPrestadoresDownload,
    EvolucaoA400Filtro,
    EvolucaoA400Download,
    PrestadoresPendentesJustificativaFiltro,
    PrestadoresPendentesJustificativaDownload,
    SubstituicaoPrestadoresDownload,
    SubstituicaoPrestadoresFiltro,
    SubstituicaoPrestadoresAgiFiltro,
    SubstituicaoPrestadoresAgiDownload,
    PrestadoresIndisponiveisAoIntercambioFiltro,
    PrestadoresIndisponiveisAoIntercambioDownload,
    PrestaoresNaoOperadoraDownload
  },
  mixins: [RelatoriosService],
  data() {
    return {
      abas: [
        {
          nome: "Seleção",
          ativo: true,
          atual: false,
          tab: "selecao"
        }
      ],
      abasVazia: [
        {
          nome: "Seleção",
          ativo: true,
          atual: false,
          tab: "selecao"
        }
      ],
      chaveRelatorio: "",
      componenteAtual: "",
      relatorioAtual: null,
      objetoFiltro: null,
      opcoesRelatorio: [],
      loading: false
    };
  },
  beforeMount() {
    this.recuperarOpcoesRelatorio();
  },
  methods: {
    recuperarOpcoesRelatorio() {
      this.loading = true;
      this.sleep(200).finally(() => {
        this.getRelatorioOpcoes()
          .then(res => {
            this.opcoesRelatorio = res.data;

            // MOCK PARA TRABALHAR NOS RELATORIOS NAO RETORNADOS PELO SERVIDOR

            // this.opcoesRelatorio.push({
            //   chave: "LISTA_PRESTADORES",
            //   descricao: "RELAÇÃO DE PRESTADORES",
            //   mensagem: "isso eh um mock"
            // });
            // this.opcoesRelatorio.push({
            //   chave: "PTU_COM_ERROS",
            //   descricao: "RELAÇÃO DE ERROS DO ÚLTIMO PTU",
            //   mensagem: "yeap"
            // });
            // console.log(this.opcoesRelatorio);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    selecionarRelatorio(chave) {
      this.chaveRelatorio = chave;
      let indexrelatorio = this.listaRelatorios.findIndex(
        e => e.chave === chave
      );
      this.relatorioAtual = this.listaRelatorios[indexrelatorio];

      if (this.relatorioAtual.filtro) {
        this.abas.push(this.abaFiltro, this.abaDownload);
        this.abas[2].ativo = false;
        this.componenteAtual = this.relatorioAtual.abaFiltro;
      } else {
        this.abas.push(this.abaDownload);
        this.abas[1].ativo = true;
        this.componenteAtual = this.relatorioAtual.abaDownload;
      }

      this.$set(this.abas[1], "atual", true);
    },
    trocarIndexAtual(index) {
      if (index === 0) {
        this.objetoFiltro = null;
        this.relatorioAtual = null;
        this.abas = JSON.parse(JSON.stringify(this.abasVazia));
      } else if (index === 1 && this.relatorioAtual.filtro) {
        this.componenteAtual = this.relatorioAtual.abaFiltro;
        this.$set(this.abas[1], "atual", true);
        this.$set(this.abas[2], "atual", false);
      } else if (index === 1) {
        this.componenteAtual = this.relatorioAtual.abaDownload;
        this.$set(this.abas[1], "atual", true);
      } else if (index === 2) {
        this.componenteAtual = this.relatorioAtual.abaDownload;
        this.$set(this.abas[1], "atual", false);
        this.$set(this.abas[2], "atual", true);
      }
    },
    proximaAbaFiltro() {
      this.componenteAtual = this.relatorioAtual.abaDownload;
      this.$set(this.abas[1], "atual", false);
      this.$set(this.abas[2], "atual", true);
    },
    habilitarStep(habilitar) {
      this.$set(this.abas[2], "ativo", habilitar);
    },
    recuperarObjetoFiltro(objetoFiltro) {
      this.objetoFiltro = JSON.parse(JSON.stringify(objetoFiltro));
    }
  },
  computed: {
    listaRelatoriosFilter() {
      return this.opcoesRelatorio;
    },
    listaRelatorios() {
      return [
        {
          chave: "PRESTADORES_PENDENTES_JUSTIFICATIVA",
          descricao: "HOSPITAIS PENDENTES",
          filtro: false,
          // abaFiltro: "PrestadoresPendentesJustificativaFiltro",
          abaDownload: "PrestadoresPendentesJustificativaDownload"
        },
        {
          chave: "ARPS_RPS_ANS",
          descricao: "REGISTRO DE PRODUTOS (ARPS/RPS – ANS)",
          filtro: true,
          abaFiltro: "ArpsRpsAnsFiltro",
          abaDownload: "ArpsRpsAnsDownload"
        },
        {
          chave: "RPS_TOTAL",
          descricao: "RPS TOTAL",
          filtro: false,
          // abaFiltro: "RpsTotalFiltro",
          abaDownload: "RpsTotalDownload"
        },
        {
          chave: "REDE_NACIONAL_PRESTADORES",
          descricao: "REDE NACIONAL DE PRESTADORES",
          filtro: false,
          // abaFiltro: "RedeNascionalPrestadoresFiltro",
          abaDownload: "RedeNascionalPrestadoresDownload"
        },
        {
          chave: "REDIMENSIONAMENTO_HOSPITALAR",
          descricao: "ALTERAÇÕES NA REDE HOSPITALAR",
          filtro: true,
          abaFiltro: "RedimensionamentoHospitalarFiltro",
          abaDownload: "RedimensionamentoHospitalarDownload"
        },
        {
          chave: "REDIMENSIONAMENTO_HOSPITALAR_AGI",
          descricao: "ALTERAÇÕES NA REDE HOSPITALAR",
          filtro: true,
          abaFiltro: "RedimensionamentoHospitalarAgiFiltro",
          abaDownload: "RedimensionamentoHospitalarAgiDownload"
        },
        {
          chave: "SUBSTITUICAO_PRESTADORES",
          descricao: "PRESTADORES EXCLUÍDOS (EXCETO HOSPITAIS)",
          filtro: true,
          abaFiltro: "SubstituicaoPrestadoresFiltro",
          abaDownload: "SubstituicaoPrestadoresDownload"
        },
        {
          chave: "SUBSTITUICAO_PRESTADORES_AGI",
          descricao: "PRESTADORES EXCLUÍDOS (EXCETO HOSPITAIS)",
          filtro: true,
          abaFiltro: "SubstituicaoPrestadoresAgiFiltro",
          abaDownload: "SubstituicaoPrestadoresAgiDownload"
        },
        {
          chave: "PTU_COM_ERROS",
          descricao: "RELAÇÃO DE ERROS DO ÚLTIMO PTU",
          filtro: true,
          abaDownload: "PtuErrosDownload",
          abaFiltro: "PtuErrosFiltro"
        },
        {
          chave: "LISTA_PRESTADORES",
          descricao: "RELAÇÃO DE PRESTADORES",
          filtro: true,
          abaFiltro: "ListaPrestadoresFiltro",
          abaDownload: "ListaPrestadoresDownload"
        },
        {
          chave: "EVOLUCAO_A400",
          descricao: "QUALIDADE DA INFORMAÇÃO ENVIADA NO PTU A400",
          filtro: true,
          abaFiltro: "EvolucaoA400Filtro",
          abaDownload: "EvolucaoA400Download"
        },
        {
          chave: "PRESTADORES_INDISPONIVEIS_AO_INTERCAMBIO",
          descricao: "PRESTADORES INDISPONÍVEIS AO INTERCÂMBIO",
          filtro: true,
          abaFiltro: "PrestadoresIndisponiveisAoIntercambioFiltro",
          abaDownload: "PrestadoresIndisponiveisAoIntercambioDownload"
        },
        {
          chave: "PRESTADORES_NAO_OPERADORA",
          descricao: "PRESTADORES UN NÃO OPERADORA",
          filtro: false,
          abaDownload: "PrestaoresNaoOperadoraDownload"
        }
      ];
    },
    abaFiltro() {
      return {
        nome: "Filtro",
        ativo: true,
        atual: false,
        tab: "filtro"
      };
    },
    abaDownload() {
      return {
        nome: "Download",
        ativo: true,
        atual: false,
        tab: "download"
      };
    }
  }
};
